import { Center , Text} from '@chakra-ui/react'
import React from 'react'

const TrainingCalendar = () => {
  return (
    <div>
        <Center width={"100%"} height={"100%"}>
            <Text>Training Calendar</Text>
            <Text>This feature is coming soon !</Text>
            {/* calendar */}
        </Center>
    </div>
  )
}

export default TrainingCalendar